var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocker1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#0175BC",
    height: 2.5,
    id: "XMLID_1489_",
    width: 2.5,
    x: 11,
    y: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 0.25,
    opacity: 0.1,
    width: 2.5,
    x: 11,
    y: 5.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 2.5,
    x: 11,
    y: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0175BC",
    height: 2.5,
    id: "XMLID_1314_",
    width: 2.5,
    x: 11,
    y: 6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 0.25,
    opacity: 0.1,
    width: 2.5,
    x: 11,
    y: 8.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 2.5,
    x: 11,
    y: 6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0175BC",
    height: 2.5,
    id: "XMLID_1315_",
    width: 2.5,
    x: 11,
    y: 9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 0.25,
    opacity: 0.1,
    width: 2.5,
    x: 11,
    y: 11.25
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 2.5,
    x: 11,
    y: 9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0175BC",
    height: 2.5,
    id: "XMLID_1307_",
    width: 2.5,
    x: 8,
    y: 6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 0.25,
    opacity: 0.1,
    width: 2.5,
    x: 8,
    y: 8.25
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 2.5,
    x: 8,
    y: 6
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0175BC",
    height: 2.5,
    id: "XMLID_1306_",
    width: 2.5,
    x: 8,
    y: 9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 0.25,
    opacity: 0.1,
    width: 2.5,
    x: 8,
    y: 11.25
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 2.5,
    x: 8,
    y: 9
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0175BC",
    height: 2.5,
    id: "XMLID_1317_",
    width: 2.5,
    x: 5,
    y: 6
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 0.25,
    opacity: 0.1,
    width: 2.5,
    x: 5,
    y: 8.25
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 2.5,
    x: 5,
    y: 6
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0175BC",
    height: 2.5,
    id: "XMLID_1316_",
    width: 2.5,
    x: 5,
    y: 9
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 0.25,
    opacity: 0.1,
    width: 2.5,
    x: 5,
    y: 11.25
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 2.5,
    x: 5,
    y: 9
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0175BC",
    height: 2.5,
    id: "XMLID_1318_",
    width: 2.5,
    x: 2,
    y: 9
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 0.25,
    opacity: 0.1,
    width: 2.5,
    x: 2,
    y: 11.25
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 2.5,
    x: 2,
    y: 9
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0175BC",
    height: 2.5,
    id: "XMLID_1305_",
    width: 2.5,
    x: 14,
    y: 9
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 0.25,
    opacity: 0.1,
    width: 2.5,
    x: 14,
    y: 11.25
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 0.25,
    opacity: 0.2,
    width: 2.5,
    x: 14,
    y: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5947266,11.223134c-0.0693359-0.0449219-1.4980469-0.9472656-2.8486328-0.7324219   c-0.3271484-1.3691406-1.5830078-2.2216797-1.6445313-2.2626953l-0.3476563-0.2314453c0,0-0.2175694,0.2255478-0.2900391,0.3007813   c-0.026474,0.027482-0.0946941,0.1059952-0.1760216,0.2478724c-0.2248478,0.3922462-0.5498848,1.268816-0.3698769,2.8903217   c0.0175781,0.1523438-0.0283203,0.3027344-0.1259766,0.4111328C17.7041016,11.9453125,17.5820313,12,17.4482422,12H0v0.5   C0,20.171875,5.5947266,21,8,21c6.1933594,0,10.4980469-3.7617188,12.3769531-7.0771484   c2.4755859-0.3945313,3.3330078-1.9497175,3.3779297-2.0239363L24,11.4838762L23.5947266,11.223134z",
    fill: "#0175BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4482422,12H0v0.25h17.4482422c0.1337891,0,0.2558594-0.0546875,0.34375-0.1533203   c0.0976563-0.1083984,0.1435547-0.2587891,0.1259766-0.4111328c-0.0057373-0.0515747-0.0048218-0.0927734-0.0095215-0.1428833   c-0.0093384,0.1130981-0.0423584,0.2217407-0.1164551,0.3040161C17.7041016,11.9453125,17.5820313,12,17.4482422,12z",
    fill: "#FFFFFF",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5947266,11.2231445c-0.0693359-0.0449219-1.4980469-0.9472656-2.8486328-0.7324219   c-0.3271484-1.3691406-1.5830078-2.2216797-1.6445313-2.2626953L18.7539063,7.996582c0,0-0.2175713,0.2255449-0.2900391,0.3007813   c-0.0198631,0.0206213-0.0630627,0.0702648-0.1175747,0.1540194c-0.1881866,0.2891331-0.5111847,0.9847698-0.4742222,2.296176   c0.0114746-1.5025024,0.5079956-2.1130981,0.5917969-2.2001953l0.2900391-0.3007813l0.3476563,0.2314453   c0.0615234,0.0410156,1.3173828,0.8935547,1.6445313,2.2626953C22.0966797,10.5258789,24,11.4838867,24,11.4838867   L23.5947266,11.2231445z",
    fill: "#FFFFFF",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7548828,11.6489258c-0.0449219,0.0742188-0.9023438,1.6293945-3.3779297,2.0239258   C18.4980469,16.9882813,14.1933594,20.75,8,20.75c-2.4052734,0-8-0.828125-8-8.5v0.25C0,20.171875,5.5947266,21,8,21   c6.1933594,0,10.4980469-3.7617188,12.3769531-7.0771484c2.4755859-0.3945313,3.3330078-1.949707,3.3779297-2.0239258   L24,11.4838867l-0.1069946-0.0688477L23.7548828,11.6489258z",
    fill: "#010101",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 1.7255629,
    x2: 21.2413311,
    y1: 8.2995186,
    y2: 17.3998699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,6H11v2.5h2.5V6z M13.5,9H11v2.5h2.5V9z M16.5,9H14v2.5h2.5V9z M13.5,3H11v2.5h2.5V3z M10.5,6   H8v2.5h2.5V6z M4.5,9H2v2.5h2.5V9z M23.5947266,11.2231445c-0.0693359-0.0449219-1.4980469-0.9472656-2.8486328-0.7324219   c-0.3271484-1.3691406-1.5830078-2.2216797-1.6445313-2.2626953L18.7539063,7.996582c0,0-0.2175903,0.2255249-0.2900391,0.3007813   c-0.0264893,0.0274658-0.0946655,0.105957-0.1760254,0.2478638c-0.2248535,0.3922119-0.5498657,1.2687988-0.369873,2.8903198   c0.0175781,0.1523438-0.0283203,0.3027344-0.1259766,0.4111328C17.7041016,11.9453125,17.5820313,12,17.4482422,12H0v0.5   C0,20.171875,5.5947266,21,8,21c6.1933594,0,10.4980469-3.7617188,12.3769531-7.0771484   c2.4755859-0.3945313,3.3330078-1.949707,3.3779297-2.0239258L24,11.4838867L23.5947266,11.2231445z M10.5,9H8v2.5h2.5V9z M7.5,6H5   v2.5h2.5V6z M7.5,9H5v2.5h2.5V9z",
    fill: "url(#SVGID_1_)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker1);
export default __webpack_public_path__ + "static/media/docker1.e5037565479ecad55ea855ff851a75f2.svg";
export { ForwardRef as ReactComponent };